import { Divider } from "antd"

const DividerInput = (props) => {
    const { text, label, dashed, textAlignment } = props

    return (
        <Divider dashed={dashed} orientation={text ? textAlignment : ""} orientationMargin={0}>{text ? label : ""}</Divider>
    )
}

export default DividerInput